import { isTeaser } from '../navigation/selectors';
import { Page, PageResponseObject } from '../settings/layout';
import { isSafeLocalPath } from './entryIntent';

// Only the root page carries comoBacked, so nested pages follow their root.
const collectPaths = (pages: PageResponseObject[], prefix = '', inheritedComoBacked?: boolean): string[] =>
  pages
    .filter(
      page =>
        page.enabled !== false && !isTeaser({ ...page, elements: page.elements || [] } as Page) && !page.isExternalUi
    )
    .reduce<string[]>((paths, page) => {
      const path = `${prefix}${page.path}`;
      const comoBacked = inheritedComoBacked === undefined ? !!page.comoBacked : inheritedComoBacked;
      return [...paths, ...(comoBacked ? [path] : []), ...collectPaths(page.subPages || [], path, comoBacked)];
    }, []);

// Returns a known route of a COMO-backed program to remember as post-login intent, or null otherwise.
export const resolveRequestedPage = (
  requested: string | null | undefined,
  pages: PageResponseObject[]
): string | null => {
  if (!requested) return null;

  const trimmed = requested.trim().replace(/(.)\/$/, '$1');
  const candidate = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;

  return isSafeLocalPath(candidate) && collectPaths(pages).includes(candidate) ? candidate : null;
};
